import React from "react";
import PageAISection from "./PageAISection";
import { shouldUseShellPageAi, resolveAiContextFromPath } from "../../utils/pageAiContent";

/** AI block for legacy/hub routes that do not use InnerPageInfographic */
export default function ShellPageAISection({ pathname }) {
  if (!shouldUseShellPageAi(pathname)) return null;
  const ctx = resolveAiContextFromPath(pathname);
  return (
    <PageAISection
      title={ctx.title}
      variant={ctx.variant}
      hubKey={ctx.hubKey}
      slug={ctx.slug}
    />
  );
}
